<template>
  <div v-if="width" v-bind:style="{ width: width + 'px', height: (7 * width / 5) + 'px' }">
    <div
      class="card-preview-page"
      v-bind:class="{ editable, 'overflow-hidden': !allowOverflow }"
      v-bind:style="{
        transform: `scale(${width / 600})`,
        'background-image': card.background.img ? `url('${card.background.img}')` : null,
        'background-color': card.background.color
      }"
    >
      <!-- Note that we set 'is-page-active' to show the template outlines if we are the card owner (only applies to some modes) -->
      <blob
        v-for="blob in blobs" :key="blob.id" :ref="blob.id"
        :class="'blob--' + blob.id"
        :mode="mode"
        :is-page-active="editable"
        :scale="1"
        :blob="blob"
        :skin="card.skin || {}"
        :is-primary="blob.user_id && (blob.user_id == globalUserId)"
        :is-card-owner="isCardOwner"
        :is-verified-recipient="isVerifiedRecipient"
        :static="static"
        @loaded="loadedIds.push(blob.id)"
        @input="x => $emit('update-blob', x)"
      />
    </div>
  </div>
  <auto-width v-else v-slot="slot" style="aspect-ratio: 5 / 7;">
    <card-preview v-if="slot.width" v-bind="$props" v-on="$listeners" :width="slot.width" />
  </auto-width>
</template>

<style>
.card-preview-page {
  position: absolute;
  width: 600px;
  height: 840px;
  transform-origin: top left;
  background-repeat: repeat;
}
.card-preview-page:not(.editable) * {
  pointer-events: none !important;
}
</style>

<script>
import AutoWidth from '@/components/AutoWidth.vue';
import Blob from '@/components/Blob.vue';
import { isBlobVisible } from '@/utils/edit-order.js';

export default {
  name: 'card-preview',

  components: {
    AutoWidth,
    Blob
  },

  props: {
    card: Object,
    mode: {
      type: String,
      default: 'view'
    },
    isCardOwner: Boolean,
    isVerifiedRecipient: Boolean,
    static: Boolean,
    allowOverflow: Boolean,

    // Optional
    width: Number,

    // You can use this property to get very basic editing capabilities on the blobs. This is really only useful when
    // used as the back of the envelope. Note that 'mode' should also be set to 'edit' if this property is true.
    editable: Boolean
  },

  data() {
    return {
      loadedIds: [],
      bgLoaded: false
    };
  },

  computed: {
    blobs() {
      return (this.card.pages[0] || { blobs: [] }).blobs.filter(x => isBlobVisible(x, this.mode, this.card.design_id));
    },

    isLoaded() {
      return (this.loadedIds.length == this.blobs.length) && this.bgLoaded;
    }
  },

  watch: {
    card: {
      immediate: true,
      async handler(v) {
        if (v.background.img) {
          this.bgLoaded = false;
          const img = document.createElement('img');
          img.src = v.background.img;
          const on = e => (new Promise(setTimeout)).then(() => this.bgLoaded = true);
          for (const key of [ 'load', 'error' ])
            img.addEventListener(key, on, { once: true });
        } else {
          this.bgLoaded = true;
        }
      }
    },

    isLoaded: {
      immediate: true,
      handler(v) {
        if (v)
          this.$emit('loaded');
      }
    }
  }
}
</script>
